import {getSignificanceBasedPrecision, human} from '@github-ui/formatters'
import type {UserInfo} from '@github-ui/repos-list-blankslate'

import type {ReposListResults} from '../types/repository-item'
import {getSortFromQuery} from '../utils/query'
import {getSortingKeyAndDirection, getSortingOptionLabel, type OrderOptions} from './sorting-options'

export function getScreenReaderMessage(
  sortingOptions: Record<string, OrderOptions>,
  defaultSortingKey: string,
  getEmptyMessage: (params: {filtered: boolean; currentPage: number; pageCount: number; userInfo?: UserInfo}) => {
    heading: string
    description?: string
  },
  isFetching: boolean,
  currentPage: number,
  query: string,
  results: ReposListResults,
  userInfo?: UserInfo,
): string {
  if (isFetching) return ''

  const {repositories, repositoryCount, pageCount} = results
  if (repositories.length === 0) {
    const {heading, description} = getEmptyMessage({filtered: !!query, currentPage, pageCount, userInfo})
    return `${heading} ${description || ''}`.trim()
  }

  const [sortKey, direction] = getSortingKeyAndDirection(getSortFromQuery(query), defaultSortingKey)
  const sortingLabel = getSortingOptionLabel(sortKey, sortingOptions)
  const sortOrder = direction === 'asc' ? 'ascending' : 'descending'
  return `${getDisplayReposCount(repositoryCount)} found. List is sorted by ${sortingLabel} in ${sortOrder} order.`
}

export function getDisplayReposCount(count: number): string {
  const displayCount = human(count, {
    precision: getSignificanceBasedPrecision(count),
  })
  return `${displayCount} ${count === 1 ? 'repository' : 'repositories'}`
}
